import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { oliApi, erroreOli } from './api';

const CAMPO = 'w-full h-11 px-3 rounded-lg border border-gray-300 mt-1';
const VUOTA = { nome: '', capacita_litri: '', tipo_olio: '', attiva: true };

export const FriggitriceDialog = ({ open, friggitrice, onClose, onSaved }) => {
  const [form, setForm] = useState(VUOTA);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm(friggitrice ? { ...VUOTA, ...friggitrice, capacita_litri: friggitrice.capacita_litri ?? '' } : VUOTA); }, [open, friggitrice]);

  const salva = async () => {
    const body = { nome: form.nome.trim(), tipo_olio: form.tipo_olio || null, attiva: form.attiva,
      capacita_litri: form.capacita_litri === '' ? null : Number(form.capacita_litri) };
    setBusy(true);
    try {
      if (friggitrice) await oliApi.put(`/friggitrici/${friggitrice.id}`, body);
      else await oliApi.post('/friggitrici', body);
      toast.success('Friggitrice salvata');
      onSaved();
    } catch (e) {
      toast.error(erroreOli(e, 'Non sono riuscito a salvare'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="oli-friggitrice-dialog">
        <DialogHeader>
          <DialogTitle>{friggitrice ? 'Modifica friggitrice' : 'Nuova friggitrice'}</DialogTitle>
          <DialogDescription>Ogni friggitrice ha il suo registro di controlli e cambi d'olio.</DialogDescription>
        </DialogHeader>
        <label className="text-sm font-medium text-gray-700">Nome
          <input value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className={CAMPO}
            placeholder="es. Friggitrice 1 (patatine)" data-testid="oli-friggitrice-nome" />
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-sm font-medium text-gray-700">Capacità (litri)
            <input type="number" step="0.5" value={form.capacita_litri} onChange={(e) => setForm({ ...form, capacita_litri: e.target.value })}
              className={CAMPO} data-testid="oli-friggitrice-capacita" />
          </label>
          <label className="text-sm font-medium text-gray-700">Olio usato
            <input value={form.tipo_olio || ''} onChange={(e) => setForm({ ...form, tipo_olio: e.target.value })} className={CAMPO}
              placeholder="es. arachide" data-testid="oli-friggitrice-olio" />
          </label>
        </div>
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input type="checkbox" checked={form.attiva} onChange={(e) => setForm({ ...form, attiva: e.target.checked })} data-testid="oli-friggitrice-attiva" />
          In uso
        </label>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} data-testid="oli-friggitrice-chiudi">Chiudi</Button>
          <Button onClick={salva} disabled={busy || !form.nome.trim()} className="bg-orange-700 hover:bg-orange-800 text-white" data-testid="oli-friggitrice-salva">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Salva'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
